import { SPLASH_LOGO_SRC } from './splash-screen';
import './splash-screen.css';

interface SplashLoaderProps {
  showLoader?: boolean;
  /**
   * Plays the entrance animation. Prefer false when the static boot splash already
   * showed the settled state (avoids a second entrance after HTML dismiss).
   */
  animate?: boolean;
}

/**
 * Branded full-viewport splash. Markup/CSS shared with the static boot splash in index.html
 * (see splash-screen.css) so both stay visually in sync without MUI.
 */
export function SplashLoader(props: SplashLoaderProps) {
  const { showLoader = true, animate = true } = props;

  const contentClassName = animate
    ? 'mi-splash__content mi-splash__content--enter'
    : 'mi-splash__content';

  return (
    <div className="mi-splash">
      <div className="mi-splash__wash" aria-hidden />
      <div className={contentClassName}>
        <img className="mi-splash__logo" src={SPLASH_LOGO_SRC} alt="MediaInbox logo" />
        {showLoader && (
          <div className="mi-splash__bar-wrap">
            <div className="mi-splash__bar">
              <div className="mi-splash__bar-indeterminate" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
